export enum StorageNamesEnum {
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  IS_REFRESHING_TOKEN = "isRefreshingToken",
  IS_LOGGED_IN = "isLoggedIn",
  HAS_SEEN_KEM_WELCOME = "hasSeenKemWelcome",
}

export enum NotificationTypeEnum {
  CHAT = "CHAT",
  REMINDER = "REMINDER",
  NEW_SUBSCRIPTION = "NEW_SUBSCRIPTION",
  GENERAL = "GENERAL",
  NEW_BLOG_POST = "NEW_BLOG_POST",
  COACH_APPOINTMENT = "COACH_APPOINTMENT",
  SUBSCRIPTION_RENEWAL = "SUBSCRIPTION_RENEWAL",
  NEW_OUTLIER = "NEW_OUTLIER",
  NEW_FORUM = "NEW_FORUM",
  ACCEPTED_CONSULT = "ACCEPTED_CONSULT",
  NEW_CONSULT = "NEW_CONSULT",
  HEALTH_DIARY = "HEALTH_DIARY",
  KEM = "KEM",
}

export enum ConstantsEnum {
  ACCEPT_COOKIES = "mdoc-user-accept-cookies",
  CLARITY_ACCEPT_COOKIES = "mdoc_user_ms_clarity_consent",
}

export enum BloodPressureBodyPositioningEnum {
  SITTING = "sitting",
  LYING_ON_THE_BACK = "lying on the back (supine)",
  LYING_ON_THE_LEFT_SIDE = "lying on the left side (left lateral)",
  LYING_ON_THE_RIGHT_SIDE = "lying on the right side (right lateral)",
  STANDING = "standing",
}

export enum DeviceConnectionState {
  NOT_CONNECTED,
  DISCONNECTING,
  CONNECTING,
  CONNECTED,
}
